import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.pageYOffset;
      setScrolled(currentScroll > 100);

      const sections = document.querySelectorAll('section[id]');
      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        if (currentScroll >= sectionTop - 200) {
          setActiveLink(section.getAttribute('id'));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleNavClick = (e, href) => {
    closeMobileMenu();
    if (!isHomePage) {
      return;
    }
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const handlePricingClick = (e) => {
    e.preventDefault();
    closeMobileMenu();
    if (isAuthenticated) {
      navigate('/dashboard/bandwidth');
    } else {
      navigate('/login', { state: { from: { pathname: '/dashboard/bandwidth' } } });
    }
  };

  return (
    <>
      {mobileMenuOpen && (
        <div className="mobile-nav-overlay" onClick={closeMobileMenu}></div>
      )}

      <nav
        className={`navbar ${scrolled ? 'scrolled' : ''} ${mobileMenuOpen ? 'menu-open' : ''}`}
        style={{
          background: scrolled || mobileMenuOpen ? 'rgba(0, 0, 0, 0.6)' : 'transparent',
          backdropFilter: scrolled || mobileMenuOpen ? 'blur(10px)' : 'none',
          boxShadow: scrolled ? '0 2px 20px rgba(0, 0, 0, 0.5)' : 'none'
        }}
      >
        <div className="container">
          <div className="nav-wrapper">
            <Link to="/" className="logo" onClick={closeMobileMenu}>
              <img src="/pathproxy.png" alt="PathProxy Logo" className="logo-image" />
              <span className="brand-name">pathproxy</span>
            </Link>

            <button
              className="mobile-menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                {mobileMenuOpen ? (
                  <>
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                  </>
                ) : (
                  <>
                    <line x1="3" y1="12" x2="21" y2="12"/>
                    <line x1="3" y1="6" x2="21" y2="6"/>
                    <line x1="3" y1="18" x2="21" y2="18"/>
                  </>
                )}
              </svg>
            </button>

            <ul className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <li>
                <Link
                  to="/"
                  className={location.pathname === '/' ? 'active' : ''}
                  onClick={closeMobileMenu}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className={location.pathname === '/faq' ? 'active' : ''}
                  onClick={closeMobileMenu}
                >
                  FAQ
                </Link>
              </li>
              <li>
                <a
                  href="/dashboard/bandwidth"
                  className={location.pathname.includes('/dashboard/bandwidth') ? 'active' : ''}
                  onClick={handlePricingClick}
                >
                  Pricing
                </a>
              </li>
              <li>
                <Link
                  to="/locations"
                  className={location.pathname === '/locations' ? 'active' : ''}
                  onClick={closeMobileMenu}
                >
                  Locations
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className={location.pathname === '/contact' ? 'active' : ''}
                  onClick={closeMobileMenu}
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to={isAuthenticated ? "/dashboard" : "/login"}
                  className="nav-dashboard-btn"
                  onClick={closeMobileMenu}
                >
                  Dashboard
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
